export default "__VITE_ASSET__CiBokWRW__"